import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';

const styles = theme => ({
  lightTooltip: {
    background: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    fontWeight: 'normal',
    fontFamily: 'arial',
    marginTop: -1,
    height: 'auto !important',
  },
  button: {
    padding: 3,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&::after': {
      content: '"\\25b4"',
      color: 'lightgrey',
      fontSize: '1.2rem',
      position: 'absolute',
      marginTop: '-3px',
    },
    '&:hover': {
      '&::after': {
        color: 'green',
      },
    },
  },
});

class ToolTip extends Component {
  static propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    title: PropTypes.node.isRequired,
    hideButton: PropTypes.bool,
  };

  render() {
    const { className, popperClassName, classes, children, title, hideButton, placement } = this.props;
    // classes={{ tooltip: classes.lightTooltip, tooltipPlacementBottom: }}
    return (
      <Tooltip
        title={title}
        placement={placement}
        classes={{ tooltip: classNames(classes.lightTooltip, className), popper: classNames(classes.tooltipPlacement, popperClassName) }}
        disableTouchListener>
        <span className={!hideButton && classes.button}>{children}</span>
      </Tooltip>
    );
  }
}

export default withStyles(styles)(ToolTip);
